document.addEventListener('DOMContentLoaded', () => {
  const marquee = document.querySelector('.oil-marquee__wrapper');

  if (marquee) {
    const splide = new Splide(marquee, {
      type: 'loop',
      clones: 12,
      drag: false,
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.6,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      gap: '24px',
      perPage: 1,
      perMove: 1,
    });

    splide.mount(window.splide.Extensions);
  }
});
